var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkAsUnread(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 6.99988C19.6569 6.99988 21 5.65673 21 3.99988C21 2.34302 19.6569 0.999878 18 0.999878C16.3431 0.999878 15 2.34302 15 3.99988C15 5.65673 16.3431 6.99988 18 6.99988Z",
    stroke: "#CACACA",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 11.9999H4.16C5.065 11.9999 5.518 11.9999 5.916 12.1829C6.314 12.3659 6.608 12.7099 7.197 13.3969L7.803 14.1029C8.392 14.7899 8.686 15.1339 9.084 15.3169C9.482 15.4999 9.934 15.4999 10.84 15.4999H11.16C12.065 15.4999 12.518 15.4999 12.916 15.3169C13.314 15.1339 13.608 14.7899 14.197 14.1029L14.803 13.3969C15.392 12.7099 15.686 12.3659 16.084 12.1829C16.482 11.9999 16.934 11.9999 17.84 11.9999H21",
    stroke: "#CACACA",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 10.9999C1 15.7139 1 18.0709 2.464 19.5349C3.93 20.9999 6.286 20.9999 11 20.9999C15.714 20.9999 18.071 20.9999 19.535 19.5349C21 18.0719 21 15.7139 21 10.9999C21 10.2799 21 9.61488 20.995 8.99988M13 1.00488C12.385 0.999878 11.72 0.999878 11 0.999878C6.286 0.999878 3.929 0.999878 2.464 2.46388C1.491 3.43788 1.164 4.80688 1.055 6.99988",
    stroke: "#CACACA",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkAsUnread);
export default __webpack_public_path__ + "static/media/markAsUnread.cecbf8b0d5631388436f3669ce59f615.svg";
export { ForwardRef as ReactComponent };